import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import axiosInstance from "./config/axiosInstance";
import DashboardAdminCombined from "./components/Admin-dashboard/DashboardAdminCombined";
import DashboardTailorCombined from "./components/Tailor-dashboard/DashboardTailorCombined";
import DashboardReceptionistCombined from "./components/Customer-dashboard/DashboardReceptionistCombined";

const DashboardCombined = () => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axiosInstance.get("/api/users/me");
        setRole(res.data.role);
      } catch (err) {
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  if (!role) return <p>Unauthorized. Please <a href="/login">login</a>.</p>;

  // Render only layout component here, child routes handled by <Outlet />
  const Layout = {
    admin: DashboardAdminCombined,
    master: DashboardTailorCombined,
    receptionist: DashboardReceptionistCombined,
  }[role];

  return <Layout><Outlet /></Layout>;
};

export default DashboardCombined;
